// src/dropdown-menu/src/dropdown-option-label.tsx
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var isLabelOption = (input) => (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  input.type === "label"
);
var OptionLabel = ({ label, compact }) => /* @__PURE__ */ jsx(
  RadixDropdownMenu.Label,
  {
    className: cx("m-2 text-xs text-surface-body", {
      "mt-2 mb-1": compact,
      "my-0": !Boolean(compact)
    }),
    children: label
  }
);

export {
  isLabelOption,
  OptionLabel
};
